import { ServerSideStoreType } from '@ag-grid-community/core';

export const defaultDataTableOptions = {
  showSidebar: true,
  showFloatingFilter: true,
  showAggFuncInHeader: false,
  enableGrouping: false,
  pageSize: 100,
  serverSideStoreType: ServerSideStoreType.Partial,
};
